import { render } from "./progress-bar.vue?vue&type=template&id=6fc11e18"
import script from "./progress-bar.vue?vue&type=script&lang=ts"
export * from "./progress-bar.vue?vue&type=script&lang=ts"
script.render = render

export default script